import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { locale } from 'beans-admin-plugin';
import _ from 'lodash';
import Element from 'element-ui';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
import localeEn from '@/locales/en';
import localeZhCN from '@/locales/zh-cn';
// import adminEn from '@/admin_i18n/en';
import adminZhCN from '@/admin_i18n/zh_cn';

Vue.use(VueI18n);

const messages = {
  zh_cn: _.merge(
    adminZhCN,
    localeZhCN
  ),
  en: _.merge(
    // adminEn,
    localeEn
  ),
}

const localeStorageKey = require('./admin-plugin-config').default.i18n.localeStorageKey;

// let defaultLocale = _.snakeCase(navigator.language);
// defaultLocale = defaultLocale.includes('en_') ? 'en' : defaultLocale;
// defaultLocale = messages[defaultLocale] ? defaultLocale : 'en';

const defaultLocale = 'zh_cn'

export const i18n = new VueI18n({
  locale: localStorage.getItem(localeStorageKey) || defaultLocale,
  fallbackLocale: defaultLocale,
  messages: _.merge({}, {
    zh_cn: locale['zh-CN'],
    en: locale['en']
  }, {
    zh_cn: elementZhLocale,
    en: elementEnLocale,
  }, messages)
});

document.title = i18n.t('documentTitle')

window.onload = function () {
  window.CKEDITOR.config.language = {
    en: 'en',
    zh_cn: 'zh-CN',
  }[i18n.locale]
}

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});
